import { render } from "./LS.vue?vue&type=template&id=494f831e"
const script = {}

import exportComponent from "/Users/connorklaassen/Documents/Programming/cklaassen.github.io/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__